import { type CoverageNeedsForm, useCoverageNeedsForm } from '@/components/Chat/useCoverageNeedsForm'
import type { EnabledCoverage } from '@/models/insuranceCoverage'
import type { InsuranceApplicationSummary } from '@/models/user'
import { type FillCardForm, useFillCardSave } from './useFillCardSave'

export interface CoverageCardForm extends FillCardForm {
  coverage: CoverageNeedsForm
}

export function useCoverageCardForm(
  orgId: string,
  application: InsuranceApplicationSummary | null | undefined,
  menu?: ReadonlyArray<EnabledCoverage>
): CoverageCardForm {
  const coverage = useCoverageNeedsForm({
    startDate: application?.desiredEffectiveDate ?? null,
    selected: application?.selectedCoverages,
    menu,
  })
  const card = useFillCardSave(orgId, [coverage])
  return { ...card, coverage }
}
